<template>
    <div class="form-row w100">
        <!-- Динамические таблицы -->
        <div 
            v-for="(group, group_index) in groupedServices" 
            :key="`group_${group_index}`" 
            class="mt-4"
            style="width: 100%; overflow-x: auto;"
        >
            <!-- <h5>Таблица: {{ group.name }}</h5> -->

            <b-table-simple small bordered responsive :caption-top="false">
                <colgroup>
                    <col 
                        v-for="col in group.columns" 
                        :class="styleTdByColKey(col.key)"
                        :key="`col_${col.key}`"
                    ></col>
                </colgroup>
                <b-thead>
                    <b-tr>
                        <b-th 
                            v-for="col in group.columns" 
                            class="super-small-th"
                            :class="[styleTdByColKey(col.key), 'align-top']"
                            :key="`head_${col.key}`"
                        >
                            {{ col.name }}
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr 
                        v-for="services_idx in group.services"
                        :key="`service_${services_idx}_${services_idx}`"
                    >
                        <b-td 
                            v-for="col in group.columns" 
                            class="super-small-td"
                            :class="[styleTdByColKey(col.key), 'align-top']"
                            :key="`col_${col.key}`"
                        >
                            <div class="text-value-td-div">
                                {{ servicesList[services_idx][col.key] || '-' }}
                            </div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </div>
</template>

<script>
export default {
    name: 'B2CServicesListDetails',
    props: {
        servicesList: Array
    },
    data() {
      return {
        loading: false,
        services: [],
        groupedServices: [],
        selectedServices: [],
      };
    },
    watch: {
        servicesList: {
            deep: true,
            immediate: true,
            handler() {
                this.formServiceGroups();
            },
        },         
    },
    mounted() {
    },
    methods: {
        formServiceGroups() {
            const groups = [];

            this.servicesList.forEach((service, s_index) => {
                const groupKey = service.columns.map((col) => col.key).sort().join('_');
                let group = groups.find((g) => g.key === groupKey);
                if (!group) {
                    group = {
                        key: groupKey,
                        name: `Группа ${groups.length + 1}`,
                        columns: service.columns.map((col) => ({
                            key: col.key,
                            name: col.name,
                            type: col.type
                        })),                        
                        services: [],
                    };

                    groups.push(group);
                }

                group.services.push(s_index);
            });

            this.groupedServices = groups;
        },
        styleTdByColKey(key) {
            switch (key) {
                case 'id':
                    return 'td-id';
                case 'name':
                    return 'td-name';
                case 'sum':
                    return 'td-sum';
                default:
                    return '';
            }
        }
    },
};
</script>

<style scoped>
    .td-id {
        width: 40px;
        max-width: 40px;
        min-width: 40px;
        text-align: center;
    }
    .td-name {
        width: auto;
    }
    .td-sum {
        width: auto;
    }
    .text-value-td-div {
        padding-top: 8px;
    }

    .super-small-th,
    .super-small-td {
        vertical-align: middle !important;
        padding: 2px 5px;
        font-size: 11px;
        border: 1px solid #CCC;
    }
    .super-small-th {
        font-size: 10px;
        padding: 3px 5px;
    }
    .super-small-td div {
        padding: 0;
    }
</style>